import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext, db } from '../../context/AuthState';
import { PageContext } from '../../context/PageState';
import { doc, getDoc } from "firebase/firestore";
import Layout from '../../partials/Layout';
import PartnerCard from '../../components/PartnerCard';

import './index.scss';

export interface IState {
  metadata?: {} | any;
  subfooter?: {} | any;
  partners: Map<string, {}> | any;
  dbLoaded: boolean;
}

const initialState: IState = {
  metadata: {},
  subfooter: {},
  partners: new Map(),
  dbLoaded: false
};

const Partners: React.FC<any> = props => {
  const [state, setState] = React.useState(initialState);
  const { user } = React.useContext(AuthContext);
  const { errors, titleSuffix} = React.useContext(PageContext);

  const objectToSortedMap = (o: { [key: string]: {} }) => {
    let map = new Map();
    let sortedKeys: string[] = Object.keys(o).sort();
    sortedKeys.forEach((k: string) => {
      map.set(k, o[k])
    })
    return map;
  }

  const properCaps = (s: string) => {
    return `${s.slice(0, 1).toUpperCase()}${s.slice(1)}`;
  }

  const scrollToRef = (ref: any) => {
    window.scrollTo(0, ref.current.offsetTop);
  }

  const id: string = useLocation().hash
  const myRef: any = useRef(id.slice(1));

  React.useEffect(() => {
    if (!user) return;

    const getPageData = async () => {
      const docRef = doc(db, "/pages/partners");
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) return props.history.push('/devices');

      const data = docSnap.data();

      setState({
          metadata: data.metadata,
          subfooter: data.subfooter,
          partners: objectToSortedMap(data.partners),
          dbLoaded: true
      });
      window.gtag('event', 'page_view', {
        page_title: data.metadata.title,
        page_location: window.location.pathname
      });
      
      /* IMPORTANT: hack solution:
          scrollToRef() is getting called before Child Component <PartnerCard> finishes rendering, leading to the scroll being off.
          Added a 100ms delay so the Map loops and child componenets can complete before scrollToRef() is called.
      */
      setTimeout(() => scrollToRef(myRef), 100);

    }

    getPageData();
      
  }, [user, props, setState, errors, titleSuffix])

  document.body.className = "layout insights partners";

  return <Layout {...state}>
    <section className="billboard my-5">
      <div className="billboard-inner">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col">
              <h2 className="hero-headline mb-3">Introducing our Partners</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    {state.partners && Array.from(state.partners.keys()).map((category: any, index: number) => {
      return <section ref={category === myRef.current ? myRef : null} key={index} className={`${category}-sec`}>
        <div className="container">
          <div className="row mb-4">
            <div className="col">
              <h3>{properCaps(category)}</h3>
            </div>
          </div>
          <div className="row">
            {state.partners.get(category).map((partner: { name: string, description: string, src: string }, index: number) => {
              return <PartnerCard key={index} name={partner.name} description={partner.description} src={partner.src} ></PartnerCard>
            })}
          </div>
        </div>
      </section>
    })}
  </Layout>;
}

export default Partners;